import { render } from "./Topbar.vue?vue&type=template&id=667da7bf&ts=true"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__